import React from "react";

interface ConditionalWrapperProps {
  condition: boolean;
  wrapper: (children: React.JSX.Element) => React.JSX.Element;
  children: React.JSX.Element;
}

/**
 * Component used to wrap children if a certain condition is true
 */
export const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperProps): React.JSX.Element => {
  if (condition) {
    return wrapper(children);
  } else {
    return children;
  }
};
